import React from 'react';
import dynamic from 'next/dynamic';
import { useOfficialHomeContext } from '@/components/overseaHome/OfficialHomeContext';
import { OFFICIAL_HOME_LOCALIZED_CONTENT } from '@/components/overseaHome/localizedContent';
import style from './index.module.scss';

const FeedbackSwiper = dynamic(() => import('./components/FeedbackSwiper'), { ssr: false });

/** 按官网请求语言展示创作者口碑区域。 */
export default function FeedbackOverview() {
  const officialHome = useOfficialHomeContext();
  // 官网 SSR 与客户端共用请求语言，独立渲染时以英文兜底。
  const content = OFFICIAL_HOME_LOCALIZED_CONTENT[officialHome?.languageCode ?? 'en'].feedbackOverview;

  return (
    <div className={style.feedbackOverview}>
      <div className={style.title}>
        <h4 className={style.titleText}>{content.title}</h4>
        <h2 className={style.titleDescription}>
          {content.description.prefix}
          <span className={style.titleDescriptionHighlight}>{content.description.highlight}</span>
        </h2>
      </div>
      <FeedbackSwiper />
    </div>
  );
}
